import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  IconButton,
  Button,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EmailIcon from "@mui/icons-material/AlternateEmail";
import PhoneIcon from "@mui/icons-material/Phone";
import LanguageIcon from "@mui/icons-material/Language";
import { tokens } from "../../../theme";

interface HaveAQuestionPopupProps {
  open: boolean;
  onClose: () => void;
}

const HaveAQuestionPopup: React.FC<HaveAQuestionPopupProps> = ({
  open,
  onClose,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const handleDownloadContact = () => {
    const vcard = `BEGIN:VCARD
        VERSION:3.0
        FN:V3 Biomedical
        ORG:V3 Biomedical
        TEL;TYPE=work,voice:(469)778-4619
        EMAIL:service@v3biomedical.com
        URL:https://v3biomed.com/externalLink
        END:VCARD`;
    const blob = new Blob([vcard], { type: "text/vcard" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "V3Biomedical.vcf";
    link.click();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          background:
            theme.palette.mode === "dark"
              ? "linear-gradient(to right, rgb(28, 35, 52),rgb(24, 53, 50))"
              : "linear-gradient(to left,rgb(129, 250, 250),rgb(126, 255, 221))",
          borderRadius: 3,
          p: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: "15px",
          fontWeight: 500,
          color: theme.palette.text.primary,
          p: 1.2,
        }}
      >
        Text/Call the V3 Team at (469) 778-4619
        <IconButton onClick={onClose} size="small" sx={{ ml: 1, p: 0.5 }}>
          <CloseIcon
            sx={{ fontSize: 20, color: theme.palette.text.secondary }}
          />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ textAlign: "center", my: 2 }}>
          <Typography fontWeight={600} fontSize="20px">
            V3 Service
          </Typography>
          <Typography fontSize="16px" color="text.secondary" mt={1}>
            V3 Biomedical
          </Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <EmailIcon sx={{ mr: 1, color: colors.success[400] }} />
          <Typography color="text.primary">service@v3biomedical.com</Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <PhoneIcon sx={{ mr: 1, color: colors.success[400] }} />
          <Typography color="text.primary">4697784619</Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <LanguageIcon sx={{ mr: 1, color: colors.success[400] }} />
          <Typography color="text.primary">v3biomed.com/externalLink</Typography>
        </Box>

        <Button
          onClick={handleDownloadContact}
          fullWidth
          sx={{
            borderRadius: "24px",
            textTransform: "none",
            fontWeight: "bold",
            py: 1.2,
            background:
              theme.palette.mode === "dark"
                ? theme.palette.primary.dark
                : theme.palette.primary.main,
            color: "#fff",
            "&:hover": {
              background: theme.palette.primary.light,
            },
          }}
        >
          Save to contacts
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default HaveAQuestionPopup;
